export const CURRENCY_SETTINGS_KEY = 'CURRENCY_SETTINGS_KEY';
export const PAYMENT_METHOD_LIST_KEY = 'PAYMENT_METHOD_LIST_KEY';
export const PAYMENT_METHOD_ONE_KEY = 'PAYMENT_METHOD_ONE_KEY';
export const CONFIG_BRANDING_KEY = 'CONFIG_BRANDING_KEY';
export const CURRENCY_RATE_ACTIVITY_KEY = 'CURRENCY_RATE_ACTIVITY_KEY';
